module.exports = __webpack_public_path__ + "img/top-people-tr.e2bc7dc5.png";